import get from 'lodash/get';

export const selectActiveFeeds = (state) => {
  const tools = get(state, 'dashboard.tools', []);
  return tools.length >= 5 ? tools[4].data : null;
};

export const selectCommandHistory = (state) => get(state, 'dashboard.commandHistory', []);
export const selectIsFetching = (state) => get(state, 'dashboard.isFetching', false);
